import {
  IExploreProduct,
  ISpecificationExploreSection
} from "@/shared/services/interface/responses/ISpecificationExplore";

export const getExploreProductToSection = (products: IExploreProduct[]) => {
  const section1 = products.filter(
    (product) =>
      product.section === ISpecificationExploreSection.MATCHED_PRODUCT
  );
  const section2 = products.filter(
    (product) =>
      product.section === ISpecificationExploreSection.USER_AND_COMMENT_COUNT
  );
  const section3 = products.filter(
    (product) =>
      product.section === ISpecificationExploreSection.LOCAL_PARTNER_SUPPORT
  );
  const section4 = products.filter(
    (product) =>
      product.section === ISpecificationExploreSection.COMPETITIVE_INDEX
  );
  const section5 = products.filter(
    (product) => product.section === ISpecificationExploreSection.PRODUCER_SCORE
  );
  return {
    section1,
    section2,
    section3,
    section4,
    section5
  };
};

const toCamelCase = (str: string): string => {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace("-", "").replace("_", "")
  );
};

export const convertToCamelCase = <T extends object>(obj: T): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => {
      if (typeof item === "object" && item !== null) {
        return convertToCamelCase(item);
      }
      return item;
    });
  }

  const result: any = {};

  Object.entries(obj).forEach(([key, value]) => {
    const camelKey = toCamelCase(key);

    if (value === null) {
      result[camelKey] = null;
    } else if (Array.isArray(value)) {
      result[camelKey] = convertToCamelCase(value);
    } else if (typeof value === "object") {
      result[camelKey] = convertToCamelCase(value);
    } else {
      result[camelKey] = value;
    }
  });

  return result;
};
